module.exports = __webpack_public_path__ + "img/tips-dollar-icon.d81730b8.svg";